import { AlertController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';
import { ApiService } from 'src/app/services/api/api.service';
import { ToastService } from 'src/app/services/toast.service';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-action-card',
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.scss'],
  standalone: false
})
export class ActionCardComponent implements OnInit {
  @Input() data: any = {};
  @Input() name: string;
  @Input() url: string;
  keys: any = [];
  id: any;
  constructor(
    private alertController: AlertController,
    private loadingService: LoadingService,
    private apiService: ApiService,
    private toastService: ToastService,
    private events: EventsService
  ) {}

  ngOnInit() {
    // let tem=this.data;
    this.id = this.data.id;

    // delete this.data.id;

    this.keys = Object.keys(this.data);
    this.keys.shift();
    // console.log(this.data);
    // console.log(this.keys)
  }

  async deleteAction(data, event) {
    event.stopPropagation();
    // console.log("del id ==> ",data.id);
    const alert = await this.alertController.create({
      message: `Are you sure want to delete this ${this.name}?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'custom-cancel-button',
          handler: () => {
            // console.log('Cancel clicked');
          },
        },
        {
          text: 'Confirm',
          cssClass: 'custom-confirm-button',
          handler: async () => {
            await this.loadingService.presentLoading('');
            this.deleteItem(data.id);
          },
        },
      ],
      cssClass: 'custom-alert-box',
    });
    await alert.present();
  }

  async deleteItem(id) {
    await this.loadingService.presentLoading('');
    this.apiService.delete(`${this.url}${id}`).subscribe(
      async (res: any) => {
        console.log(this.name);
        // console.log("delete milestone res => ", res);

        this.toastService.presentSuccessToast(res.message);
        if (this.name == 'milestone')
          this.events.publish('milestone:delete', this.data.phase_id);
        if (this.name == 'users') 
          this.events.publish('users:delete', this.data.phase_id);
        if (this.name == 'hospitals') 
          this.events.publish('hospitals:delete', this.data.phase_id);
         
        
        await this.loadingService.dismissLoader();
      },
      async (error) => {
        // console.log(error);
        await this.loadingService.dismissLoader();
        this.toastService.presentErrorToast(error.message);
      }
    );
  }
}
